/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelevanceResponse
 */
export interface RelevanceResponse {
    /**
     * 
     * @type {number}
     * @memberof RelevanceResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RelevanceResponse
     */
    code?: number;
}

export function RelevanceResponseFromJSON(json: any): RelevanceResponse {
    return RelevanceResponseFromJSONTyped(json, false);
}

export function RelevanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelevanceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function RelevanceResponseToJSON(value?: RelevanceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
    };
}


